import React from 'react';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { useBeaconNavigator } from 'src/components/BeaconV2Components/BeaconNavigation/useBeaconNavigator';
import { useBeaconClientId } from 'src/utils/Hooks/reduxSelectors';
import { BEACON_SUBTABS, BEACON_TABS } from 'src/components/BeaconV2Components/GenericSidebarNav/useBeaconRoutes';
import colors from 'src/utils/colors';

export const CreateContentButton: React.FC = () => {
  const { beaconNavigator } = useBeaconNavigator();
  const beaconClientId = useBeaconClientId();

  const handleClick = () => {
    beaconNavigator.setPathname(`/client/${beaconClientId}/generate`);
    beaconNavigator.updateSearchParams({
      tab: BEACON_TABS.PROJECTS,
      subtab: BEACON_SUBTABS.PROJECTS
    });
    beaconNavigator.go();
  };

  return (
    <SlButton
      onClick={handleClick}
      variant="contained"
      textSx={{ color: 'white' }}
      buttonSx={{
        backgroundColor: colors.darkBlue,
        borderRadius: '4px',
        border: `1px solid ${colors.darkBlue}`,
        padding: '0 20px',
        '&:hover': {
          backgroundColor: '#68727C',
          border: '1px solid #68727C'
        }
      }}
    >
      Create Content
    </SlButton>
  );
};
